import React from 'react';
import PropTypes from 'prop-types';

import Tag from './tag';

import './styles.scss';

export default function DealTaggedBody({ bodyParts }) {
  const elements = [];

  for (const [i, part] of bodyParts.entries()) {
    if (typeof part === 'string') {
      const lines = part.split('\n');
      for (let j = 0; j < lines.length; j++) {
        elements.push(<span key={`${i}-${j}`}>{lines[j]}</span>);
        if (j < lines.length - 1) {
          elements.push(<br key={`${i}-${j}-br`} />);
        }
      }
    } else {
      elements.push(<Tag key={i} tag={part} />);
    }
  }

  return <div className="deal-tagged-body flex-grow-1">{elements}</div>;
}

DealTaggedBody.propTypes = {
  bodyParts: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])).isRequired,
};
